import { Route, Routes } from 'react-router';
import { Accident } from '../../Pages/Accident/accident';
import { Home } from '../../Pages/Home/home';
import Tracking from '../../Pages/Tracking/tracking';
import { SearchComponent } from '../../Pages/search/search';
import ThirdPartyClaimPage from '../../Pages/ThirdPartyClaim';
import ThirdPartyClaimSummary from '../../Pages/ThirdPartyClaimSummary/ThirdPartyClaimSummary';
import ClaimStatus from '../../Pages/ClaimStatus/claimStatus';
import {
  ACCIDENT_ROUTE,
  HOME_ROUTE,
  SEARCH_ROUTE,
  CLAIM_STATUS_ROUTE,
  THIRD_PARTY_CLAIM_ROUTE,
  THIRD_PARTY_CLAIM_SUMMARY_ROUTE,
  TRACKING_ROUTE,
} from './constant';

type Props = {};

export const Router = (props: Props) => {
  return (
    <Routes>
      <Route path={HOME_ROUTE} element={<Home />} />
      <Route path={SEARCH_ROUTE} element={<SearchComponent />} />
      <Route path={ACCIDENT_ROUTE} element={<Accident />} />
      <Route
        path={TRACKING_ROUTE}
        element={
          <Tracking />
        }
      />
      <Route path={THIRD_PARTY_CLAIM_ROUTE} element={<ThirdPartyClaimPage />} />
      <Route path={THIRD_PARTY_CLAIM_SUMMARY_ROUTE} element={<ThirdPartyClaimSummary />} />
      <Route path={CLAIM_STATUS_ROUTE} element={<ClaimStatus />} />
    </Routes>
  );
};
